'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTemplateMaxWidth = exports.setDistance = exports.DISTANCE_KEYS = exports.setInputMetrics = exports.setBorderRadius = exports.percentToVW = exports.toPercent = exports.toPx = exports.uiLayerShadow = exports.singleDirectionModuleSpacing = exports.setUiTransition = exports.FONT_FAMILIES = exports.setFontStack = exports.setFontSmoothing = exports.setFontSize = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  font-size: ', ';\n'], ['\n  font-size: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    transition: ', ' ', ' ease-out;\n  '], ['\n    transition: ', ' ', ' ease-out;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    margin-bottom: ', ';\n    margin-top: 0;\n  '], ['\n    margin-bottom: ', ';\n    margin-top: 0;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  box-shadow: 0 ', ' ', ' 0\n    ', ';\n'], ['\n  box-shadow: 0 ', ' ', ' 0\n    ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  border-radius: ', ';\n'], ['\n  border-radius: ', ';\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    padding-bottom: ', ';\n    padding-left: ', ';\n    padding-right: ', ';\n    padding-top: ', ';\n    ', ';\n  '], ['\n    padding-bottom: ', ';\n    padding-left: ', ';\n    padding-right: ', ';\n    padding-top: ', ';\n    ', ';\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n          @media only screen and (max-width: ', ') {\n            width: 100%;\n          }\n        '], ['\n          @media only screen and (max-width: ', ') {\n            width: 100%;\n          }\n        ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    margin-top: ', ';\n    margin-bottom: ', ';\n  '], ['\n    margin-top: ', ';\n    margin-bottom: ', ';\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n  margin-left: auto;\n  margin-right: auto;\n  max-width: ', ';\n'], ['\n  margin-left: auto;\n  margin-right: auto;\n  max-width: ', ';\n']);

var _styledComponents = require('styled-components');

var _Color = require('../core/Color');

var _Style = require('../core/Style');

var _misc = require('HubStyleTokens/misc');

var misc = _interopRequireWildcard(_misc);

var _sizes = require('HubStyleTokens/sizes');

var _theme = require('HubStyleTokens/theme');

var _times = require('HubStyleTokens/times');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var setFontSize = exports.setFontSize = function setFontSize(size) {
  return (0, _styledComponents.css)(_templateObject, (0, _Style.remCalc)(size));
};

var setFontSmoothing = exports.setFontSmoothing = function setFontSmoothing(smoothing) {
  var computedSmoothing = smoothing || 'antialiased';

  // No `css` wrapper for this mixin, due to a bug in styled-components v3
  return '\n    -webkit-font-smoothing: ' + computedSmoothing + ';\n    -moz-osx-font-smoothing: ' + (computedSmoothing === 'antialiased' ? 'grayscale' : computedSmoothing) + ';\n  ';
};

// note: just a template literal, not using css function
var setFontStack = exports.setFontStack = function setFontStack(family) {
  return '\n  font-family: \'' + family + '\', ' + misc.FALLBACK_FONT_STACK + ';\n';
};

var FONT_FAMILIES = exports.FONT_FAMILIES = {
  bold: function bold() {
    return '\n        ' + setFontStack(misc.WEB_FONT_BOLD) + ';\n        font-weight: ' + misc.WEB_FONT_BOLD_WEIGHT + ';\n      ';
  },
  demibold: function demibold() {
    return '\n        ' + setFontStack(misc.WEB_FONT_DEMI_BOLD) + ';\n        font-weight: ' + misc.WEB_FONT_DEMI_BOLD_WEIGHT + ';\n      ';
  },
  medium: function medium() {
    return '\n        ' + setFontStack(misc.WEB_FONT_MEDIUM) + ';\n        font-weight: ' + misc.WEB_FONT_MEDIUM_WEIGHT + ';\n      ';
  },
  italic: function italic() {
    return '\n        ' + setFontStack(misc.WEB_FONT_ITALIC) + ';\n        font-style: italic;\n        font-weight: ' + misc.WEB_FONT_ITALIC_WEIGHT + ';\n      ';
  },
  default: function _default() {
    return '\n        ' + setFontStack(misc.WEB_FONT_REGULAR) + ';\n        font-weight: ' + misc.WEB_FONT_REGULAR_WEIGHT + ';\n      ';
  }
};

var setUiTransition = exports.setUiTransition = function setUiTransition(property, timing) {
  var computedTiming = timing || _times.MICRO_TRANSITION_TIMING;
  var computedProperty = property || 'all';

  return (0, _styledComponents.css)(_templateObject2, computedProperty, computedTiming);
};

var singleDirectionModuleSpacing = exports.singleDirectionModuleSpacing = function singleDirectionModuleSpacing(size) {
  var computedSize = size || parseInt(_sizes.BASE_SINGLE_DIRECTION_MARGIN, 10);
  return (0, _styledComponents.css)(_templateObject3, (0, _Style.remCalc)(computedSize));
};

var uiLayerShadow = exports.uiLayerShadow = function uiLayerShadow() {
  return (0, _styledComponents.css)(_templateObject4, _sizes.BASE_SHADOW_OFFSET_Y, _sizes.BASE_SHADOW_BLUR_RADIUS, (0, _Color.rgba)(_theme.BASE_SHADOW_COLOR, parseFloat(_sizes.BASE_SHADOW_ALPHA)));
};

var toPx = exports.toPx = function toPx(value) {
  return typeof value === 'number' ? value + 'px' : value;
};

var toPercent = exports.toPercent = function toPercent(value) {
  return value == null ? undefined : value + '%';
};

var percentToVW = exports.percentToVW = function percentToVW(width) {
  if (typeof width !== 'string') return width;
  return width.replace(/(\d+)%/g, '$1vw');
};

var setBorderRadius = exports.setBorderRadius = function setBorderRadius() {
  var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _sizes.BUTTON_RADIUS;
  return (0, _styledComponents.css)(_templateObject5, toPx(radius));
};

var setInputMetrics = exports.setInputMetrics = function setInputMetrics() {
  var padVertical = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _sizes.BUTTON_DEFAULT_PADDING_Y;
  var padHorizontal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _sizes.BUTTON_DEFAULT_PADDING_X;
  var padRight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : padHorizontal;
  var padBottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : padVertical;
  var responsive = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  return (0, _styledComponents.css)(_templateObject6, padBottom, padHorizontal, padRight, padVertical, responsive ? (0, _styledComponents.css)(_templateObject7, _sizes.GRID_BREAKPOINT_SMALL) : null);
};

var DISTANCE_SIZES = {
  flush: 0,
  'extra-small': _sizes.DISTANCE_MEASUREMENT_EXTRA_SMALL,
  small: _sizes.DISTANCE_MEASUREMENT_SMALL,
  medium: _sizes.DISTANCE_MEASUREMENT_MEDIUM,
  large: _sizes.DISTANCE_MEASUREMENT_LARGE,
  'extra-large': _sizes.DISTANCE_MEASUREMENT_EXTRA_LARGE
};

var DISTANCE_KEYS = exports.DISTANCE_KEYS = Object.keys(DISTANCE_SIZES);

var setDistance = exports.setDistance = function setDistance() {
  var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medium';

  var size = DISTANCE_SIZES[distance];
  return (0, _styledComponents.css)(_templateObject8, size, size);
};

/**
 * @returns a mixin that sets the appropriate width and margins to match a page template with
 * `pageLayout="max-width"`.
 */
var setTemplateMaxWidth = exports.setTemplateMaxWidth = function setTemplateMaxWidth() {
  return (0, _styledComponents.css)(_templateObject9, toPx(parseInt(_sizes.LAYOUT_MAX_WIDTH, 10) + parseInt(_sizes.LAYOUT_PADDING_X, 10) * 2));
};